import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../assests/imagenes/La_Romana_logo_completo_color.svg";
import "./Bienvenida.css";

export default function Bienvenida() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/carta");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bienvenida">
      <img src={logo} alt="logo la romana" className="logo" />
    </div>
  );
}
